import React, { useState, useEffect, useLayoutEffect } from 'react';
import bem from 'utils/bem';
import InnerImageZoom from 'react-inner-image-zoom';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';

import './index.sass';
import { Skeleton } from '@mui/material';
import { times } from 'utils/render';
import { IconButton } from 'components/Button';

const { block, el } = bem('photo-gallery');

const PhotoGallery = ({ items }) => {
    const [currentItem, setCurrentItem] = useState(0);

    const onNavClick = (index) => () => {
        setCurrentItem(index);
    }

    const onClickNext = () => {
        setCurrentItem(oldCurrent => {
            return Math.min(++oldCurrent, items.length - 1)
        })
    }
    const onClickPrev = () => {
        setCurrentItem(oldCurrent => {
            return Math.max(--oldCurrent, 0)
        })
    }

    useLayoutEffect(() => {
        setCurrentItem(0);
    }, [items])

    return (
        <div className={ block() }>
            <div className={ el('big') }>
                <InnerImageZoom className={ el('image') } src={ items[currentItem]?.thumbnail }
                                zoomSrc={ items[currentItem]?.original } hideHint={ true }/>
            </div>
            <div className={ el('bottom')}>
                <IconButton className={el('button')} mod={'transparent-gold'} name={'arrow-left'} onClick={onClickPrev} type={'button'} disabled={currentItem === 0}/>
                <div className={ el('navigation') }>
                    <div className={ el('tape') }
                         style={ { transform: `translateX(${ -(115) * (currentItem > 1 ? currentItem < items.length - 1 ? currentItem - 1 : currentItem - 2 : 0) }px)` } }>
                        { items.map((item, index) =>
                            <div key={ index } onClick={ onNavClick(index) }
                                 className={ el('navigation-item', { 'selected': index === currentItem }) }>
                                <img src={ item.thumbnail }/>
                            </div>) }
                    </div>
                </div>
                <IconButton className={el('button')} mod={'transparent-gold'} name={'arrow-right'} onClick={onClickNext} type={'button'} disabled={currentItem === items.length - 1} />
            </div>
        </div>
    )
}

export const PhotoGallerySkeleton = () => {
    return (
        <div className={ block() }>
            <div className={ el('big') }>
                <Skeleton variant={'rectangular'} height={'100%'} style={{borderRadius: '10px'}}/>
            </div>
            <div className={ el('bottom')}>
                <Skeleton variant={'rectangular'} height={'44px'} width={'44px'} style={{borderRadius: '10px'}}/>
                <div className={ el('navigation') }>
                    <div className={ el('tape') }>
                        { times((key) => <div key={ key } className={ el('navigation-item') }><Skeleton variant={'rectangular'} height={'100%'} style={{borderRadius: '10px'}}/></div>, 3) }
                    </div>
                </div>
                <Skeleton variant={'rectangular'} height={'44px'} width={'44px'} style={{borderRadius: '10px'}}/>
            </div>
        </div>
    )
}

export default PhotoGallery;
